export enum PersistedState {
  Segments = "segments",
  Stack = "stack",
  Timer = "timer",
  StackSaved = "stack-saved",
}
